module.exports = vendor_90d823b6adbb901ef699;